import {NotepadComponent} from './notepad.component';
import {NgModule} from '@angular/core';
import {SecureURLPipeModule} from '../util/secureURL.pipe.module';
import {CommonModule} from '@angular/common';

@NgModule({
    imports: [
        SecureURLPipeModule,
        CommonModule
    ],
    declarations: [NotepadComponent],
    providers: [],
    exports: [NotepadComponent],
})

export class NotepadModule {

}